export const TitanEmailIcon = (props) => 
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
    <circle cx={16} cy={16} r={16} fill="#DADEFF" />
    <path
      fill="#4B55AF"
      d="M23.922 11.51 19.05 16.35l4.872 4.841c.088-.184.142-.387.142-.605v-8.472c0-.218-.053-.421-.142-.605ZM22.654 10.703H9.412c-.218 0-.421.054-.605.142l6.227 6.196c.551.55 1.446.55 1.997 0l6.228-6.196a1.397 1.397 0 0 0-.605-.142ZM8.142 11.51a1.396 1.396 0 0 0-.142.605v8.472c0 .218.053.421.142.605l4.872-4.841-4.872-4.841Z"
    />
    <path
      fill="#4B55AF"
      d="m18.386 17.017-.69.69a2.356 2.356 0 0 1-3.327 0l-.69-.69-4.872 4.841c.184.088.387.142.605.142h13.242c.217 0 .42-.053.605-.142l-4.873-4.84Z"
    />
  </svg>
;
